import AuthService from "@/services/auth.service";
import { Notification } from "element-ui";

export const AuthErrorHandler = (error: any) => {
  //Check if its an auth error. Else, reject the promise.
  if (error.response) {
    if (401 === error.response.status) {
      // Special case. 401 error -> logout
      Notification.error("Su sesión ha caducado");
      AuthService.logout();
    }
  } else if (error.request) {
    return Promise.reject(
      "No se ha podido establecer la conexión. ¿Ha comprobado su conexión a internet?"
    );
  }
  return Promise.reject(error);
};
